export default __webpack_public_path__ + "static/media/06_photo.09d28155.jpg";